export default "__VITE_ASSET__c9yK8GmM__"